module.exports = __webpack_public_path__ + "img/512.6fa69ca2.png";